import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { ModalidadAutorizacion} from '../_models/modalidad-autorizacion';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ModalidadAutorizacionService {

  private rutServicioModalidad = AppSettings.rutServiciosAPL + '/api/modalidadesAutorizaciones';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listadoModalidadesAutorizaciones() {
    return this.httClient.get( this.rutServicioModalidad ).pipe( map( res => res as ModalidadAutorizacion[] ) );
  }

  listadoModalidadesAutorizacionesHabilitadas() {
    return this.httClient.get( this.rutServicioModalidad + '/enabled' ).pipe( map( res => res as ModalidadAutorizacion[] ) );
  }

  listadoModalidadesAutorizacionesIdModalidad(id: string) {
    return this.httClient.get( this.rutServicioModalidad + '/modalidad/' + id ).pipe( map( res => res as ModalidadAutorizacion[] ) );
  }
  listadoModalidadesAutorizacionesHabilitadasIdModalidad(id: string) {
    return this.httClient.get( this.rutServicioModalidad + '/modalidad/' + id + '/enabled' ).pipe( map( res => res as ModalidadAutorizacion[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicioModalidad + '/' + id ).pipe( map( res => res as ModalidadAutorizacion ) );
  }

  crear( modalidadAutorizacion: ModalidadAutorizacion ) {
    modalidadAutorizacion.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicioModalidad, modalidadAutorizacion ).pipe( map( res => res as ModalidadAutorizacion ) );
  }

  actualizar( modalidadAutorizacion: ModalidadAutorizacion ) {
    modalidadAutorizacion.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicioModalidad, modalidadAutorizacion ).pipe( map( res => res as any ) );
  }


}
